export const currencyRequiredValidator = {
    attribute: 'required',
    key: 'valueMissing',
    message(instance) {
        if (instance.errorMessages && instance.errorMessages.valueMissing) {
            if (instance.errorMessages.valueMissing instanceof Function) {
                return instance.errorMessages.valueMissing(instance);
            }
            return instance.errorMessages.valueMissing;
        }
        return `${instance.displayName ? instance.displayName : 'This field'} is required`;
    },
    isValid(instance, value) {
        let valid = true;
        if ((instance.hasAttribute('required') || instance.required) &&
            (!value || value === instance.defaultInitialValue)) {
            valid = false;
        }
        return valid;
    },
};
export const currencyMaxValidator = {
    attribute: 'max',
    key: 'rangeOverflow',
    message(instance) {
        if (instance.errorMessages && instance.errorMessages.rangeOverflow) {
            if (instance.errorMessages.rangeOverflow instanceof Function) {
                return instance.errorMessages.rangeOverflow(instance);
            }
            return instance.errorMessages.rangeOverflow;
        }
        return `${instance.displayName ? `${instance.displayName} must be` : 'Enter a dollar amount'} less than or equal to ${instance.max}`;
    },
    isValid(instance) {
        /** If max isn't set, this is valid */
        if (!instance.max) {
            return true;
        }
        if (!!instance.value) {
            const formattedValue = instance.value.replace(/[$,]/g, '');
            if (!!formattedValue && parseFloat(instance.max) < parseFloat(formattedValue)) {
                return false;
            }
        }
        return true;
    },
};
export const currencyMinValidator = {
    attribute: 'min',
    key: 'rangeUnderflow',
    message(instance) {
        if (instance.errorMessages && instance.errorMessages.rangeOverflow) {
            if (instance.errorMessages.rangeOverflow instanceof Function) {
                return instance.errorMessages.rangeOverflow(instance);
            }
            return instance.errorMessages.rangeOverflow;
        }
        return `${instance.displayName ? `${instance.displayName} must be` : 'Enter a dollar amount'} greater than or equal to ${instance.min}`;
    },
    isValid(instance) {
        /** If min isn't set, this is valid */
        if (!instance.min) {
            return true;
        }
        if (!!instance.value) {
            const formattedValue = instance.value.replace(/[$,]/g, '');
            if (!!formattedValue && parseFloat(instance.min) > parseFloat(formattedValue)) {
                return false;
            }
        }
        return true;
    },
};
export const currencyPatternValidator = {
    attribute: 'pattern',
    key: 'patternMismatch',
    message(instance) {
        if (instance.errorMessages && instance.errorMessages.patternMismatch) {
            if (instance.errorMessages.patternMismatch instanceof Function) {
                return instance.errorMessages.patternMismatch(instance);
            }
            return instance.errorMessages.patternMismatch;
        }
        return 'Enter a valid dollar amount';
    },
    isValid(instance, value) {
        if (instance.validationTarget && value !== instance.defaultInitialValue) {
            // reverse the browser validity
            return !instance.validationTarget.validity.patternMismatch;
        }
        return true;
    },
};
//# sourceMappingURL=currency-validators.js.map